import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const ComptaPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default ComptaPage